(function() {
    'use strict';

    angular
        .module('completeAir')
        .factory('printService', printService);

    function printService () {

        return {
            printPdfHtml: printPdfHtml,
            print: print,
            printIFrame: printIFrame
        };

        function printPdfHtml (sectionId) {
            var printContents, popupWin;
            printContents = document.getElementById(sectionId).innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=80%,width=auto');
            popupWin.document.open();
            popupWin.document.write('<html>' +
                '<head>' +
                '<title>Invoice</title>' +
                '<link rel="stylesheet" type="text/css" href="../../../assets/css/style-pdf.css" />' +
                '</head>' +
                '<body onload="window.print();window.close();">'
                + printContents +
                '</body>' +
                '</html>');
            popupWin.document.close();
            return true;
        }

        function print (sectionId) {
            var printContents, popupWin;
            printContents = document.getElementById(sectionId).innerHTML;
            popupWin = window.open('', '_blank', 'top=0,left=0,height=80%,width=auto');
            popupWin.document.open();
            popupWin.document.write('<html>' +
                '<head>' +
                '<title>Invoice</title>' +
                '<link rel="stylesheet" type="text/css" href="../../../assets/css/print.css" />' +
                '</head>' +
                '<body onload="window.print();window.close();">'
                + printContents +
                '</body>' +
                '</html>');
            popupWin.document.close();
            return true;
        }

        function printIFrame(sectionId) {
            const contents = document.getElementById(sectionId).innerHTML;
            const frame1 = document.createElement('iframe');
            frame1.name = 'framePrint';
            frame1.style.position = 'absolute';
            frame1.style.top = '-1000000px';
            document.body.appendChild(frame1);
            const frameDoc = frame1.contentWindow ? frame1.contentWindow : frame1.contentDocument['document']
                ? frame1.contentDocument['document'] : frame1.contentDocument;
            frameDoc.document.open();
            frameDoc.document.write('<html><head>');
            frameDoc.document.write('<link rel="stylesheet" type="text/css" href="../../../assets/css/print.css" />');
            //frameDoc.document.write('<style type="text/css" media="print">@media print{@page{size:auto;margin:0}@page :left{margin-left:0;margin-right:0}@page :right{margin-left:0;margin-right:0}@page{size:auto;margin:0;padding:0}@page :first{margin-top:0}body{font-size:8pt!important;font-family:\'Helvetica Neue\',Arial,Helvetica;color:#000}.font-size-8{font-size:8px;}.font-size-9{font-size:9px}.font-size-10{font-size:10px}.font-size-11{font-size:11px}.font-size-12{font-size:12px}.font-size-13{font-size:13px}.font-size-14{font-size:14px}.font-size-15{font-size:15px}.my-0{margin-top:0;margin-bottom:0}.mx-0{margin-left:0!important;margin-right:0!important}.mt-0{margin-top:0!important}.mt-1{margin-top:5px!important}.mt-2{margin-top:10px!important}.mt-3{margin-top:15px!important}.mb-0{margin-bottom:0!important}.mb-1{margin-bottom:5px!important}.mb-2{margin-bottom:10px!important}.mb-3{margin-bottom:15px!important}.bold{font-weight:700}.text-uppercase{text-transform:uppercase}.text-capitalize{text-transform:capitalize}.hr-border{border-bottom:medium none;border-top:1px solid #525252}.text-center{text-align:center}.width-print-245{width:260px!important}.content-invoice-print{display:block!important;padding:4px}.table{background-color:transparent;border-spacing:0;border-collapse:collapse!important;font-size:11px;width:100%;max-width:100%;margin-bottom:5px}.table>tbody>tr>td,.table>tbody>tr>th,.table>tfoot>tr>td,.table>tfoot>tr>th,.table>thead>tr>td,.table>thead>tr>th{padding:0;line-height:1.42857143;vertical-align:top;text-align:left}.table>thead>tr>th{vertical-align:bottom;border-top:1px solid #525252;border-bottom:1px solid #525252}.table>tbody>tr:last-child>td,.table>tbody>tr:last-child>th{border-top:1px solid #525252}.table>tfoot>tr>td:first-child{text-align:right}.border-ticket{border:4px solid #525252}.page-break-after{page-break-after:always;height:1px}.TDBOX13{font-size:13px;font-family:arial;color:#000;padding:1px;border:4px solid #525252;border-style:solid;border-width:thin}}</style>')
            frameDoc.document.write('</head><body>');
            frameDoc.document.write(contents);
            frameDoc.document.write('</body></html>');
            frameDoc.document.close();
            setTimeout(function () {
                window.frames['framePrint'].focus();
                window.frames['framePrint'].print();
                document.body.removeChild(frame1);
            }, 500);
            return false;
        }
    }
})();
